export var DANCE_AI_SOUNDS = [
    'ai-select-emoji',
    'ai-deselect-emoji',
    'ai-generate-no',
    'ai-generate-yes',
];
